const PHONE_LIKE_REGEX = /^[+\d\s\-()]+$/;
const MIN_PHONE_DIGITS = 6;

export function isPhoneLike(value: string | null | undefined): boolean {
  if (value === null || value === undefined) {
    return false;
  }

  const trimmed = value.trim();
  if (trimmed === '') {
    return false;
  }

  if (!PHONE_LIKE_REGEX.test(trimmed)) {
    return false;
  }

  const digits = trimmed.replace(/\D+/g, '');
  return digits.length >= MIN_PHONE_DIGITS;
}
